import React from "react"

import _ from "lodash"
import PropTypes from "prop-types"

import { NoSuggestions } from "./atoms"
import { DecidedInfo, PlanHeader, SuggestionsList } from "./molecules"
import { PlanWrapper, PlanBlock } from "./previewGamePlanWhenStyles"

export const PreviewGamePlan = ({ type, gameplan, isLoading }) => {
  const renderContent = () => {
    if (gameplan?.suggestions.length) {
      return gameplan?.decidedSuggestion ? (
        <DecidedInfo
          type={type}
          decidedSuggestion={gameplan?.decidedSuggestion}
        />
      ) : (
        <SuggestionsList type={type} suggestions={gameplan?.suggestions} />
      )
    } else {
      return <NoSuggestions type={type} isLoading={isLoading} />
    }
  }

  return (
    <PlanWrapper isFirst data-testid={_.capitalize(type)}>
      <PlanHeader type={type} decidedSuggestion={gameplan?.decidedSuggestion} />

      <PlanBlock>{renderContent()}</PlanBlock>
    </PlanWrapper>
  )
}

PreviewGamePlan.propTypes = {
  type: PropTypes.string,
  gameplan: PropTypes.any,
  isLoading: PropTypes.bool,
}
